import React from "react";
import { PersonIcon } from "./icons/PersonIcon";
import { PhoneIcon } from "./icons/PhoneIcon";
import { LocationIcon } from "./icons/LocationIcon";
import { EmailIcon } from "./icons/EmailIcon";
import { DocumentIcon } from "./icons/DocumentIcon";
import { CalendarIcon } from "./icons/CalendarIcon";
import { TextAlignIcon } from "./icons/TextAlignIcon";
import { HashIcon } from "./icons/HashIcon";
import { ListIcon } from "./icons/ListIcon";

const ICON_BY_KEY: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  first_name: PersonIcon,
  last_name: PersonIcon,
  email: EmailIcon,
  phone: PhoneIcon,
  address_1: LocationIcon,
  address_2: LocationIcon,
  zone_code: LocationIcon,
  city: LocationIcon,
  zip: LocationIcon,
  identity_document: DocumentIcon,
};

const ICON_BY_TYPE: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  email: EmailIcon,
  tel: PhoneIcon,
  date: CalendarIcon,
  text: TextAlignIcon,
  textarea: TextAlignIcon,
  number: HashIcon,
  select: ListIcon,
};

/**
 * Resolves the appropriate icon component for a field.
 * Looks up by key first (built-in fields), then falls back to type (custom fields).
 * Returns null if no icon is mapped.
 */
export function getFieldIcon(
  key: string,
  type: string
): React.ReactNode | null {
  const IconComponent = ICON_BY_KEY[key] || ICON_BY_TYPE[type];
  if (!IconComponent) return null;
  return <IconComponent />;
}
